import { FormattedMessage } from 'react-intl';

import type { ActionBannerState } from './banner-context';
import * as S from './banner.styles';

type SuccessBannerProps = {
  handleOnClose?: () => void;
  successState: ActionBannerState;
  disableFocusTrap?: boolean;
};

export const SuccessBanner: React.FC<SuccessBannerProps> = ({
  handleOnClose,
  successState,
  disableFocusTrap,
}) => {
  const { message, action, actionMessage, visible } = successState;
  return message ? (
    <S.StatusBanner
      display="fixed"
      show={visible}
      variant="success"
      handleOnClose={handleOnClose}
      focusTrapProps={{ active: !disableFocusTrap }}
    >
      <FormattedMessage
        id={message}
        values={{
          b: (chunks) => <strong>{chunks}</strong>,
        }}
        tagName="span"
      />
      {action && actionMessage ? (
        <S.BannerAction onClick={action}>
          <FormattedMessage id={actionMessage} />
        </S.BannerAction>
      ) : null}
    </S.StatusBanner>
  ) : null;
};
